import axios, { AxiosError, AxiosResponse } from 'axios'
import { isCurrentPathAnonymousBrandFlow } from '../config/brands.config'
import { isWhatsAppCheckoutPath } from '../utils/renderActions'
import { getGAClientId, getGASessionId } from '../utils/googleAnalytics'

const locationHost = window.location.host
export const baseURL =
  locationHost.includes('homolog') || locationHost.includes('localhost')
    ? import.meta.env.VITE_APP_HOMOL_BASE_URL
    : import.meta.env.VITE_APP_BASE_URL

const api = axios.create({ baseURL })

export const defaultsHeadersAxios = (token: string) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`
}

api.interceptors.request.use(
  async (config) => {
    const storedParams = sessionStorage.getItem('utmParams')
    let utmParams: Record<string, string> = {}

    if (storedParams) {
      utmParams = JSON.parse(storedParams) as Record<string, string>
    }

    const gaClientId = await getGAClientId()
    const gaSessionId = await getGASessionId()

    if (!config.headers) {
      config.headers = {} as any
    }

    if (gaClientId) {
      config.headers['x-ga-client-id'] = gaClientId
    }
    if (gaSessionId) {
      config.headers['x-ga-session-id'] = gaSessionId
    }

    if (config.method === 'post' || config.method === 'put') {
      if (config.data instanceof FormData) {
        Object.keys(utmParams).forEach((key) => {
          config.data.append(key, utmParams[key])
        })

        if (gaClientId) config.data.append('ga_client_id', gaClientId)
        if (gaSessionId) config.data.append('ga_session_id', gaSessionId)
      } else {
        config.data = {
          ...config.data,
          utmParams,
          ga_client_id: gaClientId,
          ga_session_id: gaSessionId
        }
      }
    }

    return config
  },
  (error) => {
    return error
  }
)

const responseSuccessInterceptor = (response: AxiosResponse) => response

const responseErrorInterceptor = async (error: AxiosError) => {
  const responseStatus = error.response?.status
  const lowerPath = (window.location.pathname || '').toLowerCase()

  const isPublicFlow =
    lowerPath.startsWith('/detalhes-do-pedido') ||
    lowerPath.startsWith('/nps') ||
    lowerPath.startsWith('/validacao-documentos') ||
    isWhatsAppCheckoutPath(lowerPath) ||
    // Whitelabel sem tela de login (Remederi/Vikura): um 401 aqui não pode
    // redirecionar — mandar para /login da Cannect quebra o funil da marca.
    isCurrentPathAnonymousBrandFlow()
  const isAspaecFlow = lowerPath.startsWith('/aspaec') || lowerPath.startsWith('/areaassociados')

  if (responseStatus === 401) {
    localStorage.removeItem('@CANNECT_TOKEN_API')
    if (!isPublicFlow) {
      const loginPath = isAspaecFlow ? '/AreaAssociados' : '/login'
      window.location.replace(`${window.location.origin}${loginPath}`)
    }
  }

  return Promise.reject(error)
}

api.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor)

export default api
